import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import {
  Card,
  Box,
  Button,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  TextField,
  Autocomplete,
} from "@mui/material";
import OutlinedInput from '@mui/material/OutlinedInput';
import { BaseTable } from "src/components/BaseTable/BaseTable";
import Page from "src/components/Page";
import { useAccess } from "src/hooks/useAccess.hook";
import enums, { FEATURE } from "src/util/enums";
import axios from "../../util/axios";
import {
  reportListColumn,
  reportStatusList,
  reportTabListToShow,
} from "./ReportTabList.constant";
import { ReactComponent as TotalEnergy } from "../../image/total_energy.svg";
import { ReactComponent as TotalRevenue } from "../../image/total_revenue.svg";
import { ReactComponent as TotalSession } from "../../image/total_session.svg";
import { styled } from "@mui/material/styles";
import {
  isValidTimeInterval,
} from "src/utils/formatTime";
import { format, parse } from "date-fns";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import {
  getAllExistedTeam,
  reportExcelDownload,
  reportTabData,
  reportTabHeaderData,
} from "src/react-query/endPoints";
import { RootTabItemStyles, RootTabStyle } from "src/theme/overrides/Tabs";
import {
  // DatePicker,
  // LocalizationProvider,
  TabContext,
  TabList,
  TabPanel,
} from "@mui/lab";
// import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { downloadCSV } from "src/utils/convertAnddownloadCsv";
import { useNavigate } from "react-router-dom";
import { downloadExcel } from "src/utils/downloadExcel";
import { useAuth } from "src/hooks/useAuth.hook";
import { useList } from "src/hooks/useFetch.hook";
import { useDispatch } from "react-redux";
import { alertSlice } from "src/store/alert/alert.slice";
import Checkbox from "@mui/material/Checkbox";
import PayoutReportTab from "./PayoutReportTab";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "src/react-query/queryKeys";
import { fetchWithError } from "src/react-query/fetchWithError";
import { selector } from "src/react-query/select";
import { subscriptionDetailsColumns } from "src/components/Team/teams.constants";
import SubscriptionDetailsModal from "src/components/Team/SubscriptionDetailsModal";
import { IconButton, Tooltip as MuiTooltip } from "@mui/material";
import { Icon as IconifyIcon } from "@iconify/react";
import downloadFill from "@iconify/icons-eva/download-fill";

const BoxStyle = styled("div")(({ theme }) => ({
  width: "100%",
  border: "1px solid #00000036",
  display: "grid",
  gridTemplateRows: "20% 80%",
  placeItems: "center",
  padding: "1rem",
  borderRadius: "10px",
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const {
  actions: { setAlert },
} = alertSlice;

const ReportTabList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const allTimeMenu = ["Last 7 days", "Last 30 days", "Last 90 days", "Custom"];
  const [isCustomSelect, setIsCustomSelect] = useState(false);
  const [timeInterval, setTimeInterval] = useState();
  const [tableData, setTableData] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [headerData, setHeaderData] = useState();
  const [getDate, setGetDate] = useState({ startDate: null, endDate: null });
  const isReadOnly = useAccess(FEATURE.REPORT, "RP");
  const finalTableColumns = reportListColumn(isReadOnly);
  const { teamId, teamType: selectedTeamType, teamName: selectedTeamName } = useSelectedTeam();
  const [selectedTab, setSelectedTab] = useState("Statement Report Tab");
  const tabsToShow = [
    { value: "Statement Report Tab", label: "Statement Report Tab" },
    { value: "Payout Report Tab", label: "Payout Report Tab" },
    { value: "charger-licenses", label: "Charger Licenses" },
  ];

  // Charger licenses tab state
  const [selectedLicenseTeam, setSelectedLicenseTeam] = useState(null);
  const [licenseSubscriptionData, setLicenseSubscriptionData] = useState([]);
  const [licenseSubscriptionModalOpen, setLicenseSubscriptionModalOpen] = useState(false);
  const [selectedLicenseSubscriptionRow, setSelectedLicenseSubscriptionRow] = useState(null);
  const [selectedLicenseRows, setSelectedLicenseRows] = useState([]);
  const reportTabListToShowData = reportTabListToShow();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { user } = useAuth();
  const companyType = useMemo(() => {
    return user?.company?.companyType;
  }, [user]);
  const [allTeamsData, setAllTeamsData] = useState();
  const [dummyTeamData, setDummyTeamData] = useState();
  const [chargeBoxList, setChargeBoxList] = useState();
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState([]);
  const [chargeBoxName, setChargeBoxName] = useState([]);
  const [payoutStatus, setPayoutStatus] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const datesForPicker = [
    { label: "Start Date", value: "start_date" },
    { label: "End Date", value: "end_date" },
  ];
  const isSelectAllTriggeredRef = useRef(false);
  const isTeamSelectAllTriggeredRef = useRef(false);
  const isChargeBoxSelectAllTriggeredRef = useRef(false);
  const payoutSelectAllTriggeredRef = useRef(false);

  const rowOrCellClickRedirect = ({ id }) => {
    // if(isReadOnly) return;
    navigate(`/transactions/${id}`);
  };

  const errorNotification = () => {
    return dispatch(
      setAlert({
        open: true,
        message: "Please select a valid time interval",
        severity: enums.SEVERITY.ERROR,
      })
    );
  };

  const { data: chargers } = useList("chargers", true, { c: false });

  // Auto-select team for license tab based on header context type
  useEffect(() => {
    if (!user) return;
    if (selectedTeamType === "T") {
      if (teamId && selectedTeamName) {
        setSelectedLicenseTeam({ teamId, teamName: selectedTeamName });
      }
    } else if (user?.role?.length) {
      setSelectedLicenseTeam(user.role[0]);
    }
  }, [user, teamId, selectedTeamType, selectedTeamName]);

  const { data: licenseApiData, isFetching: isTeamDetailsFetching } = useQuery(
    queryKeys.teamChargerLicenseReport(selectedLicenseTeam?.teamId),
    fetchWithError,
    { enabled: selectedTab === "charger-licenses" && !!selectedLicenseTeam?.teamId, select: selector }
  );

  useEffect(() => {
    if (!selectedLicenseTeam) { setLicenseSubscriptionData([]); return; }
    if (!licenseApiData) return;
    const licenses = Array.isArray(licenseApiData) ? licenseApiData : licenseApiData?.chargerLicenses ?? [];
    setLicenseSubscriptionData(
      licenses.map((license, index) => ({
        id: license?.licensePk || index + 1,
        licensePk: license?.licensePk,
        licenseId: license?.licenseId,
        status: license?.status,
        chargerId: license?.chargeBoxId,
        chargerCreationDate: license?.createdAt,
        chargerSubscriptionExpiryDate: license?.expiry,
        duration: license?.duration,
        final_expiry: license?.final_expiry,
        contractSummary: license?.summary,
        remarks: license?.remarks,
        chargerType: license?.chargerType,
        invoiceFilePath: license?.invoice_file_path || "",
        invoiceNumber: license?.invoice_number || "",
      }))
    );
  }, [licenseApiData, selectedLicenseTeam]);

  const handleLicenseSubscriptionDetailsOpen = useCallback((row) => {
    setSelectedLicenseSubscriptionRow(row);
    setLicenseSubscriptionModalOpen(true);
  }, []);

  const handleLicenseSubscriptionDetailsClose = useCallback(() => {
    setLicenseSubscriptionModalOpen(false);
    setSelectedLicenseSubscriptionRow(null);
  }, []);

  const triggerDownload = useCallback((url) => {
    const filename = url.split("/").pop().split("?")[0] || "invoice.pdf";
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      })
      .catch(() => {
        // fallback: open in new tab if fetch fails (e.g. CORS blocked)
        window.open(url, "_blank", "noopener,noreferrer");
      });
  }, []);

  const openInvoice = useCallback((url) => {
    triggerDownload(url);
  }, [triggerDownload]);

  const handleDownloadSelectedInvoices = useCallback(() => {
    const uniqueUrls = [
      ...new Set(selectedLicenseRows.map((r) => r.invoiceFilePath).filter(Boolean)),
    ];
    uniqueUrls.forEach((url, i) => {
      setTimeout(() => triggerDownload(url), i * 300);
    });
  }, [selectedLicenseRows, triggerDownload]);

  const hasSelection = selectedLicenseRows.length > 0;

  const licenseReportColumns = useMemo(() => [
    ...subscriptionDetailsColumns(handleLicenseSubscriptionDetailsOpen, false, null, false),
    {
      field: "invoiceFilePath",
      headerName: "Invoice",
      width: 80,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) =>
        row.invoiceFilePath ? (
          <MuiTooltip title={hasSelection ? "Deselect rows to use individual download" : (row.invoiceNumber || "Download Invoice")} placement="top">
            <span>
              <IconButton
                size="small"
                onClick={() => openInvoice(row.invoiceFilePath)}
                disabled={hasSelection}
              >
                <IconifyIcon icon={downloadFill} width={18} />
              </IconButton>
            </span>
          </MuiTooltip>
        ) : (
          <span style={{ color: "#bbb", fontSize: 12 }}>—</span>
        ),
    },
  ], [handleLicenseSubscriptionDetailsOpen, openInvoice, hasSelection]);

  useEffect(() => {
    if (user?.company?.id === teamId) {
      setAllTeamsData(dummyTeamData);
    } else {
      const team = dummyTeamData?.filter(
        (list) => list.parentCompanyId === teamId
      );
      setAllTeamsData(team);
    }
  }, [teamId, dummyTeamData]);

  useEffect(() => {
    try {
      const getAllTeam = async () => {
        const response = await axios.get(getAllExistedTeam(teamId));
        setAllTeamsData(response.data.data);
        setDummyTeamData(response.data.data);
      };
      companyType === "GP" && getAllTeam();
    } catch (err) {
      console.log(err);
    }
  }, [companyType]);

  const handleChangeTimeInterval = (value) => {
    if (value === "Custom") {
      setIsCustomSelect(true);
      return;
    }
    setIsCustomSelect(false);
    let date = new Date();
    date.setHours(0, 0, 0, 0);
    let startDate = format(date, "yyyy-MM-dd HH:mm:ss");
    setTimeInterval(value);
    switch (value) {
      case "Today":
        {
          let endDate = new Date();
          setGetDate({
            startDate: startDate,
            endDate: format(endDate, "yyyy-MM-dd HH:mm:ss"),
          });
        }
        break;
      case "Yesterday":
        {
          let ystrDate = new Date().setDate(new Date().getDate() - 1);
          let actualDate = format(
            new Date(ystrDate).setHours(0, 0, 0, 0),
            "yyyy-MM-dd HH:mm:ss"
          );
          setGetDate({
            startDate: actualDate,
            endDate: format(
              new Date(actualDate).setHours(23, 59, 59),
              "yyyy-MM-dd HH:mm:ss"
            ),
          });
        }
        break;
      case "Last 7 days":
        {
          let endDate = new Date().setDate(new Date().getDate() - 7);
          setGetDate({
            startDate: format(
              new Date(endDate).setHours(0, 0, 0, 0),
              "yyyy-MM-dd HH:mm:ss"
            ),
            endDate: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          });
        }
        break;
      case "Last 30 days":
        {
          let endDate = new Date().setDate(new Date().getDate() - 30);
          setGetDate({
            startDate: format(
              new Date(endDate).setHours(0, 0, 0, 0),
              "yyyy-MM-dd HH:mm:ss"
            ),
            endDate: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          });
        }
        break;
      case "Last 90 days":
        {
          let endDate = new Date().setDate(new Date().getDate() - 90);
          setGetDate({
            startDate: format(
              new Date(endDate).setHours(0, 0, 0, 0),
              "yyyy-MM-dd HH:mm:ss"
            ),
            endDate: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          });
        }
        break;
      default:
        break;
    }
  };

  const saveToExcel = async () => {
    try {
      let reportListPayload = {
        startDate: getDate?.startDate,
        endDate: getDate?.endDate,
        companyFilter: companyType === "P" ? [] : selectedCompany,
        teamfilter: companyType === "P" ? selectedCompany : selectedTeam,
        chargeBoxFilter: chargeBoxName,
        statusFilter: payoutStatus,
      };

      const response = await axios.post(
        reportExcelDownload(teamId),
        reportListPayload,
        {
          responseType: "blob",
        }
      );

      downloadExcel(response.data, "report");
    } catch (error) {
      console.error("Error downloading the Excel file", error);
    }
  };

  const handleTabChange = (e, tab) => {
    setSelectedTab(tab);
  };

  function convertArrayOfObjectsToCSV(arrayOfObjects) {
    if (
      !arrayOfObjects ||
      !Array.isArray(arrayOfObjects) ||
      arrayOfObjects.length === 0
    ) {
      return "";
    }
    const rows = arrayOfObjects.map((object) => {
      const values = Object.values(object).map((value) => `"${value}"`);
      return values.join("; ");
    });
    return rows.join("\n");
  }

  const handleExport = () => {
    const csv = convertArrayOfObjectsToCSV(tableData);
    downloadCSV(csv, "Transaction_Report");
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    setPaginationModel({ page: newPage, pageSize: pageSize });
  };

  const handleChangeCompany = (e) => {
    let value = e.target.value;
    if (Array.isArray(value)) value = value.filter((v) => v !== 'all');
    setSelectedCompany(value);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    if (companyType === "GP" && value.length > 0) {
      const teamFilterValue = dummyTeamData.filter((filter) =>
        value.includes(filter.parentCompanyId)
      );
      setAllTeamsData(teamFilterValue);
    } else {
      setAllTeamsData(dummyTeamData);
      setSelectedTeam([])
    }
    if (companyType === "P" && value.length > 0) {
      const chargeBoxFilter = (chargers?.chargers || chargers).filter((filter) =>
        value.includes(filter.teamId)
      );
      setChargeBoxList(chargeBoxFilter);
    } else {
      setChargeBoxList((chargers?.chargers || chargers));
      setChargeBoxName([]);
    }
  };

  const handleChangeTeam = (e) => {
    let value = e.target.value;
    if (Array.isArray(value)) value = value.filter((v) => v !== 'all');
    setSelectedTeam(value);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    });
    if (value.length > 0) {
      const chargeBoxFilter = (chargers?.chargers || chargers).filter((filter) =>
        value.includes(filter.teamId)
      );
      setChargeBoxList(chargeBoxFilter);
    } else {
      setChargeBoxList((chargers?.chargers || chargers));
      setChargeBoxName([]);
    }
  };

  const handleChangeChargeBox = (e) => {
    let value = e.target.value;
    if (Array.isArray(value)) value = value.filter((v) => v !== 'all');
      setChargeBoxName(value);
    if(!value.length > 0){
      setPayoutStatus([]);
    }
  };

  const handleChangeStatus = (e) => {
    let value = e.target.value;
    if (Array.isArray(value)) {
      value = value.filter((v) => v !== 'all' && v !== undefined);
    }
    setPayoutStatus(value);
  };

  const handleSelectAllClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isAll = isAllSelected(reportStatusList, payoutStatus);
    const newValue = isAll ? [] : reportStatusList;

    payoutSelectAllTriggeredRef.current = true;
    handleChangeStatus({ target: { value: newValue } });
  };

  useEffect(() => {
    const getReportData = async () => {
      try {
        let reportListPayload = {
          startDate: getDate?.startDate,
          endDate: getDate?.endDate,
          page,
          pageSize,
          companyFilter: companyType === "P" ? [] : selectedCompany,
          teamfilter: companyType === "P" ? selectedCompany : selectedTeam,
          chargeBoxFilter: chargeBoxName,
          statusFilter: payoutStatus,
        };

        const response = await axios.post(
          reportTabData(teamId),
          reportListPayload
        );
        if (response.data.data) {
          setIsFetching(false);
          setTableData(response.data.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (
      (selectedCompany?.length > 0 || user?.company?.id !== teamId) && 
      getDate?.startDate &&
      getDate?.endDate &&
      isValidTimeInterval({
        start: getDate.startDate,
        end: getDate.endDate,
      })
    ) {
      setTimeInterval(`${getDate.startDate} - ${getDate.endDate}`);
      if(selectedTeam?.length > 0 || user?.company?.id === teamId){
        getReportData();
      } else if(((companyType === "P" && user?.company?.id !== teamId) || companyType === "T") && chargeBoxName.length > 0){
        getReportData();
      }
    } else if (getDate?.startDate && getDate?.endDate && isValidTimeInterval({
      start: getDate.startDate,
      end: getDate.endDate,
    })) {
      errorNotification();
    }
  }, [
    getDate,
    page,
    pageSize,
    selectedCompany,
    selectedTeam,
    chargeBoxName,
    payoutStatus,
  ]);

  useEffect(() => {
    const getReportData = async () => {
      try {
        let headerListPayload = {
          startDate: getDate?.startDate,
          endDate: getDate?.endDate,
          companyFilter: companyType === "P" ? [] : selectedCompany,
          teamfilter: companyType === "P" ? selectedCompany : selectedTeam,
          chargeBoxFilter: chargeBoxName,
          statusFilter: payoutStatus,
        };

        const headerResponse = await axios.post(
          reportTabHeaderData(teamId),
          headerListPayload
        );
        if (headerResponse.data.data) {
          setHeaderData(headerResponse.data.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (
      (selectedCompany?.length > 0 || user?.company?.id !== teamId) &&
      getDate?.startDate &&
      getDate?.endDate &&
      isValidTimeInterval({
        start: getDate.startDate,
        end: getDate.endDate,
      })
    ) {
      if(selectedTeam?.length > 0 || user?.company?.id === teamId){
        getReportData();
      } else if(((companyType === "P" && user?.company?.id !== teamId) || companyType === "T") && chargeBoxName.length > 0){
        getReportData();
      }
    }
  }, [getDate, selectedCompany, selectedTeam, chargeBoxName, payoutStatus]);

  const onChangeDateRange = async (value, type) => {
    setIsFetching(true);
    if (type === "start_date") {
      const dateAtMidnight = new Date(value);
      dateAtMidnight.setHours(0, 0, 0, 0);
      const startDate = format(dateAtMidnight, "yyyy-MM-dd HH:mm:ss");
      setGetDate((prev) => ({ ...prev, startDate }));
    } else {
      const dateAtEndOfDay = new Date(value);
      dateAtEndOfDay.setHours(23, 59, 59, 999);
      const endDate = format(dateAtEndOfDay, "yyyy-MM-dd HH:mm:ss");
      setGetDate((prev) => ({ ...prev, endDate }));
    }
  };

  // Helper for Select All logic
  const isAllSelected = (options = [], selected = []) => {
    const allIds = options.map(item => item.teamId || item.companyId || item.boxId || item);
    return allIds.length > 0 && allIds.every(id => selected.includes(id));
  };

  return (
    <Page title="Report | Smart-CMS">
      <TabContext value={selectedTab}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            borderBottom: "1px solid",
            borderColor: "divider",
          }}
        >
          <RootTabStyle
            indicatorColor="transparent"
            centered
            length={tabsToShow.length}
            onChange={handleTabChange}
          >
            {tabsToShow.map((tab) => (
              <RootTabItemStyles
                key={tab.value}
                value={tab.value}
                label={tab.label}
              />
            ))}
          </RootTabStyle>
        </Box>
        <Card sx={{ p: 4 }}>
        <TabPanel value="Statement Report Tab">
        
          <Stack direction={{ xs: "column", sm: "row" }} // Column for mobile, row for larger screens
                sx={{
                  gap: { xs: "2rem", sm: "4rem" }, // Smaller gap for mobile, larger for windows
                }}>
            <BoxStyle>
              <Typography
                mt={2}
                mb={1}
                sx={{ fontWeight: "600", fontSize: { xs: "14px", sm: "16px" },}}
              >
                Total Energy
              </Typography>
              <Box sx={{ display: "flex", placeItems: "center", gap: "2rem" }}>
                <TotalEnergy />
                <Box sx={(theme) => ({ color: theme.palette.primary.main })}>
                  <Typography
                    sx={{
                      display: "inline-block",
                      fontWeight: "600",
                      fontSize: "2rem",
                    }}
                  >
                    {headerData?.totalEnergy?.toFixed(2)}
                  </Typography>
                  <Typography sx={{ display: "inline-block" }}>KwH</Typography>
                </Box>
              </Box>
            </BoxStyle>
            <BoxStyle>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  placeItems: "center",
                }}
              >
                <Typography
                  mb={1}
                  mt={2}
                  sx={{ fontWeight: "600", fontSize: { xs: "14px", sm: "16px" }, }}
                >
                  Total Revenue
                </Typography>
                <Typography
                  mb={1}
                  sx={{ marginTop: "-10px", fontSize: { xs: "10px", sm: "12px" },  }}
                >
                  (CPO Payout)
                </Typography>
              </Box>
              <Box sx={{ display: "flex", placeItems: "center", gap: "2rem" }}>
                <TotalRevenue />
                <Typography
                  sx={(theme) => ({ color: theme.palette.primary.main, fontWeight: "600", fontSize: "2rem" })}
                >
                  {headerData?.totalRevenue?.toFixed(2)}
                </Typography>
              </Box>
            </BoxStyle>
            <BoxStyle>
              <Typography
                mb={1}
                mt={2}
                sx={{ fontWeight: "600", fontSize: "16px" }}
              >
                Total Session
              </Typography>
              <Box sx={{ display: "flex", placeItems: "center", gap: "2rem" }}>
                <TotalSession />
                <Typography
                  sx={(theme) => ({ color: theme.palette.primary.main, fontWeight: "600", fontSize: "2rem" })}
                >
                  {headerData?.totalCount}
                </Typography>
              </Box>
            </BoxStyle>
          </Stack>
          <Box>
            <Typography
              mt={4}
              sx={{
                borderBottom: "2px solid #00000036",
                paddingBottom: "12px",
                fontSize: { xs: "0.9rem", sm: "1rem" }, // Adjust font size for mobile
              }}
            >
              STATEMENT REPORT
            </Typography>
            <Grid container mt={4} mb={4} sx={{ gridRowGap: "2rem" }}>
              <>
                {(companyType === "GP" || companyType === "P") &&
                  user?.company?.id === teamId && (
                    <Grid item lg={3} md={4} xs={6}>
                      <FormControl size="small" sx={{ width: { xs: "95%", sm: "200px" } }}>
                        <InputLabel id="demo-simple-select-label"
                        sx={{ fontSize: { xs: "12px", sm: "16px" } }} 
                        >
                          {companyType === "GP"
                            ? "Select Company"
                            : "Select Team"}
                        </InputLabel>
                        <Select
                          labelId="demo-multiple-name-label"
                          id="demo-multiple-name"
                          multiple
                          value={selectedCompany}
                          onChange={(e) => {
                            if (isSelectAllTriggeredRef.current) {
                              isSelectAllTriggeredRef.current = false;
                              return;
                            }
                            handleChangeCompany(e);
                          }}
                          input={<OutlinedInput label={companyType === "GP"
                            ? "Select Company"
                            : "Select Team"} />}
                          MenuProps={MenuProps}
                          renderValue={(selected) =>
                            user?.role
                              ?.filter((team) => team.teamId !== user?.company?.id)
                              ?.filter((team) => selected.includes(team.teamId))
                              ?.map((team) => team.teamName)
                              .join(", ")
                          }
                          sx={{
                            width: "100%",
                            fontSize: { xs: "12px", sm: "14px" },
                          }}
                        >
                          <MenuItem
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();

                              const options = user?.role?.filter((team) => team.teamId !== user?.company?.id) || [];
                              const allIds = options.map((team) => team.teamId);
                              const isSelectedAll = isAllSelected(options, selectedCompany);
                              const newValue = isSelectedAll ? [] : allIds;

                              isSelectAllTriggeredRef.current = true;
                              handleChangeCompany({ target: { value: newValue } });
                            }}
                          >
                            <Checkbox
                              checked={isAllSelected(user?.role?.filter((team) => team.teamId !== user?.company?.id), selectedCompany)}
                              indeterminate={
                                selectedCompany.length > 0 &&
                                !isAllSelected(user?.role?.filter((team) => team.teamId !== user?.company?.id), selectedCompany)
                              }
                            />
                            Select All
                          </MenuItem>

                          {user?.role
                            ?.filter((team) => team.teamId !== user?.company?.id)
                            ?.map((team) => (
                              <MenuItem
                                key={team.teamId}
                                value={team.teamId}
                                onClick={() => {
                                  const selectedIndex = selectedCompany.indexOf(team.teamId);
                                  let newSelected = [];
                                  if (selectedIndex === -1) {
                                    newSelected = [...selectedCompany, team.teamId];
                                  } else {
                                    newSelected = selectedCompany.filter((id) => id !== team.teamId);
                                  }
                                  setSelectedCompany(newSelected);
                                }}
                              >
                                <Checkbox checked={selectedCompany.indexOf(team.teamId) > -1} />
                                {team.teamName}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}
                {companyType === "GP" && (
                  <Grid lg={3} md={4} xs={6}>
                    <FormControl
                      size="small"
                      disabled={
                        selectedCompany.length > 0 ||
                        user?.company?.id !== teamId
                          ? false
                          : true
                      }
                      sx={{ width: { xs: "100%", sm: "200px" } }}
                    >
                      <InputLabel id="demo-multiple-name-label"
                       sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                      >
                        Team Name
                      </InputLabel>
                      <Select
                        labelId="demo-multiple-name-label"
                        id="demo-multiple-name"
                        multiple
                        value={selectedTeam}
                        onChange={(e) => {
                          if (isTeamSelectAllTriggeredRef.current) {
                            isTeamSelectAllTriggeredRef.current = false;
                            return;
                          }
                          handleChangeTeam(e);
                        }}
                        input={<OutlinedInput label="Team Name" />}
                        MenuProps={MenuProps}
                        renderValue={selected =>
                          allTeamsData?.filter(team => selected.includes(team.companyId))?.map(team => team.companyName).join(", ")
                        }
                        sx={{
                          width: "100%",
                          fontSize: { xs: "12px", sm: "14px" },
                        }}
                      >
                        <MenuItem
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            const options = allTeamsData || [];
                            const allIds = options.map(team => team.companyId);
                            const newValue = isAllSelected(options, selectedTeam) ? [] : allIds;
                            
                            isTeamSelectAllTriggeredRef.current = true;
                            handleChangeTeam({ target: { value: newValue } });
                          }}
                        >
                          <Checkbox
                            checked={isAllSelected(allTeamsData, selectedTeam)}
                            indeterminate={selectedTeam.length > 0 && !isAllSelected(allTeamsData, selectedTeam)}
                          />
                          Select All
                        </MenuItem>
                        {allTeamsData?.length > 0 &&
                          allTeamsData.map(team => (
                            <MenuItem
                              key={team.companyId}
                              value={team.companyId}
                              onClick={() => {
                                const selectedIndex = selectedTeam.indexOf(team.companyId);
                                let newSelected = [];
                                if (selectedIndex === -1) {
                                  newSelected = [...selectedTeam, team.companyId];
                                } else {
                                  newSelected = selectedTeam.filter(id => id !== team.companyId);
                                }
                                setSelectedTeam(newSelected);
                              }}
                            >
                              <Checkbox checked={selectedTeam.indexOf(team.companyId) > -1} />
                              {team.companyName}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </>
              <Grid lg={3} md={4} xs={6}>
                <FormControl
                  size="small"
                  disabled={
                    selectedTeam.length > 0 ||
                    (companyType === "P" && selectedCompany.length > 0) ||
                    (companyType === "P" && user?.company?.id !== teamId)
                      ? false
                      : true
                  }
                  sx={{ width: { xs: "100%", sm: "200px" } }}
                >
                  <InputLabel id="demo-multiple-name-label"
                   sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                  >
                    Charge Box Id
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    input={<OutlinedInput label="Charge Box Id" />}
                    value={chargeBoxName}
                    onChange={(e) => {
                      if (isChargeBoxSelectAllTriggeredRef.current) {
                        isChargeBoxSelectAllTriggeredRef.current = false;
                        return;
                      }
                      handleChangeChargeBox(e);
                    }}
                    MenuProps={MenuProps}
                    renderValue={selected => selected.join(", ")}
                    sx={{
                      width: "95%",
                      fontSize: { xs: "12px", sm: "14px" },
                    }}
                  >
                    <MenuItem
                     onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const options =
                          (companyType === "P" && user?.company?.id !== teamId) || companyType === "T"
                            ? (chargers?.chargers || chargers)
                            : chargeBoxList;

                        const allIds = options?.map((charger) => charger.chargepoint_id) || [];
                        const isAll = isAllSelected(options, chargeBoxName);

                        isChargeBoxSelectAllTriggeredRef.current = true;

                        // Use the same handler
                        handleChangeChargeBox({
                          target: {
                            value: isAll ? [] : allIds,
                          },
                        });
                      }}
                      autoFocus={false}
                    >
                      <Checkbox
                          checked={(() => {
                          const options =
                            (companyType === "P" && user?.company?.id !== teamId) || companyType === "T"
                              ? (chargers?.chargers || chargers)
                              : chargeBoxList;
                          return isAllSelected(options, chargeBoxName);
                        })()}
                        indeterminate={(() => {
                          const options =
                            (companyType === "P" && user?.company?.id !== teamId) || companyType === "T"
                              ? (chargers?.chargers || chargers)
                              : chargeBoxList;
                          return chargeBoxName.length > 0 && !isAllSelected(options, chargeBoxName);
                        })()}
                      />
                      Select All
                    </MenuItem>
                    {((companyType === "P" && user?.company?.id !== teamId) || companyType === "T")
                      ? (chargers?.chargers || chargers)?.map((charger) => (
                          <MenuItem
                            key={charger.chargepoint_pk}
                            value={charger.chargepoint_id}
                             onClick={() => {
                              const selectedIndex = chargeBoxName.indexOf(charger.chargepoint_id);
                              let newSelected = [];
                              if (selectedIndex === -1) {
                                newSelected = [...chargeBoxName, charger.chargepoint_id];
                              } else {
                                newSelected = chargeBoxName.filter((id) => id !== charger.chargepoint_id);
                              }
                              setChargeBoxName(newSelected);
                              if (!newSelected.length) {
                                setPayoutStatus([]);
                              }
                            }}
                            sx={{fontSize: { xs: "12px", sm: "14px" } }}
                          >
                            <Checkbox checked={chargeBoxName.includes(charger.chargepoint_id)} />
                            {charger.chargepoint_id}
                          </MenuItem>
                        ))
                      : chargeBoxList?.map((charger) => (
                          <MenuItem
                            key={charger.chargepoint_pk}
                            value={charger.chargepoint_id}
                            onClick={() => {
                              const selectedIndex = chargeBoxName.indexOf(charger.chargepoint_id);
                              let newSelected = [];
                              if (selectedIndex === -1) {
                                newSelected = [...chargeBoxName, charger.chargepoint_id];
                              } else {
                                newSelected = chargeBoxName.filter(id => id !== charger.chargepoint_id);
                              }
                              setChargeBoxName(newSelected);
                            }}
                            sx={{fontSize: { xs: "12px", sm: "14px" } }}
                          >
                            <Checkbox checked={chargeBoxName.indexOf(charger.chargepoint_id) > -1} />
                            {charger.chargepoint_id}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={3} md={4} xs={6}>
                <FormControl size="small" disabled={!chargeBoxName.length > 0}
                  sx={{ width: { xs: "100%", sm: "200px" } }}
                >
                  <InputLabel id="demo-multiple-name-label"
                  sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                  >
                    Payout Status
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={payoutStatus}
                    input={<OutlinedInput label="Payout Status" />}
                    //onChange={handleChangeStatus}
                    onChange={(e) => {
                      if (payoutSelectAllTriggeredRef.current) {
                        payoutSelectAllTriggeredRef.current = false;
                        return; // skip this if triggered from "Select All"
                      }
                      handleChangeStatus(e);
                    }}
                    MenuProps={MenuProps}
                    renderValue={selected => selected.join(", ")}
                    sx={{
                      width: "100%",
                      fontSize: { xs: "12px", sm: "14px" },
                    }}
                  >
                    <MenuItem onClick={handleSelectAllClick}
                      autoFocus={false}
                    >
                      <Checkbox
                        checked={isAllSelected(reportStatusList, payoutStatus)}
                        indeterminate={
                          payoutStatus.length > 0 &&
                          !isAllSelected(reportStatusList, payoutStatus)
                        }
                      />
                      Select All
                    </MenuItem>
                    {reportStatusList?.map((status) => (
                      <MenuItem
                        key={status}
                        value={status}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          const isSelected = payoutStatus.includes(status);
                          const newSelected = isSelected
                            ? payoutStatus.filter((s) => s !== status)
                            : [...payoutStatus, status];
                          setPayoutStatus(newSelected);
                        }}
                        sx={{fontSize: { xs: "12px", sm: "14px" },
                        }}
                      >
                        <Checkbox checked={payoutStatus.indexOf(status) > -1} />
                        {status}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid lg={3} md={4} xs={6}>
                <FormControl size="small" disabled={selectedCompany.length > 0 || selectedTeam.length > 0 || chargeBoxName.length > 0 ? false : true}
                   sx={{ width: { xs: "100%", sm: "200px" } }}
                >
                  <InputLabel id="demo-simple-select-label"
                  sx={{ fontSize: { xs: "12px", sm: "16px" } }}
                  >
                    Date
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"                    
                    label="Date"
                    value={timeInterval}
                    onChange={(event) =>
                      handleChangeTimeInterval(event.target.value)
                    }
                    sx={{
                      width: { xs: "95%", sm: "100%" },
                      fontSize: { xs: "12px", sm: "14px" }, 
                    }}
                  >
                    {allTimeMenu.map((data) => (
                      <MenuItem key={data} value={data} 
                      sx={{ fontSize: { xs: "12px", sm: "14px" } }}
                      >
                        {data}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              {isCustomSelect && (
                <Grid lg={6} md={6} xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row", // Align items in a single row
                      alignItems: "center",
                      gap: { xs: 2, sm: 4 }, // Adjust spacing between elements
                      flexWrap: "nowrap", // Prevent wrapping
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        whiteSpace: "nowrap",
                      }}
                    >
                      Custom Range:
                    </Typography>

                    {datesForPicker.map((list) => (
                      <LocalizationProvider
                        key={list.value}
                        dateAdapter={AdapterDateFns}
                      >
                        <Box sx={{ minWidth: { xs: "100px", sm: "140px" } }}>
                          <DatePicker
                            label={list.label}
                            value={
                              list.value === "start_date"
                                ? getDate.startDate
                                  ? parse(getDate.startDate, "yyyy-MM-dd HH:mm:ss", new Date())
                                  : null
                                : getDate.endDate
                                  ? parse(getDate.endDate, "yyyy-MM-dd HH:mm:ss", new Date())
                                  : null
                            }
                            onChange={(val) => onChangeDateRange(val, list.value)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                size="small"
                                sx={{
                                  width: { xs: "120px", sm: "160px" }, // Adjust width for mobile and desktop
                                  "& .MuiInputBase-input": {
                                    fontSize: { xs: "12px", sm: "14px" },
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontSize: { xs: "11px", sm: "14px" },
                                  },
                                }}
                              />
                            )}
                          />
                        </Box>
                      </LocalizationProvider>
                    ))}
                  </Box>
                </Grid>
              )}
              {tableData?.length > 0 && (
                <Grid lg={3} md={4} xs={6}>
                  <Button
                    variant="contained"
                    onClick={saveToExcel}
                    sx={{ whiteSpace: "pre" }}
                  >
                    Export To Excel
                  </Button>
                </Grid>
              )}
            </Grid>
            {tableData?.length > 0 && (
              <BaseTable
                isReadOnly={isReadOnly}
                rows={tableData ?? []}
                columns={finalTableColumns}
                loading={isFetching}
                getRowId={(row) => row.transactionId}
                pageSize={pageSize}
                showExportCsvBtn={false}
                rowOrCellClickRedirect={rowOrCellClickRedirect}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                totalRows={headerData?.totalCount || 0}
                serverRowFetcher={true}
                rowsPerPageOptions={[10, 30, 50, 100]}
                paginationModel={paginationModel}
                sx={{
                  ".MuiDataGrid-columnHeaderTitle": {
                    overflow: "hidden   !important",
                    lineHeight: "20px   !important",
                    whiteSpace: "normal  !important",
                  },
                }}
              />
            )}
          </Box>
       
        </TabPanel>
        <TabPanel value="Payout Report Tab">
          <PayoutReportTab />
        </TabPanel>
         {/* </Card> */}
        {/* </Card> */}
        {/* </TabPanel> */}

        <TabPanel value="charger-licenses" sx={{ p: 0 }}>
          {/* <Card sx={{ p: 4 }}> */}
            <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ sm: "center" }} justifyContent="space-between" spacing={2} sx={{ mb: 2 }}>
              <Autocomplete
                size="small"
                sx={{ width: { xs: "100%", sm: 280 } }}
                options={selectedTeamType === "T"
                  ? [{ teamId, teamName: selectedTeamName }].filter((o) => o.teamId)
                  : (user?.role ?? [])}
                getOptionLabel={(option) => option.teamName ?? ""}
                isOptionEqualToValue={(option, value) => option.teamId === value.teamId}
                value={selectedLicenseTeam}
                onChange={(_, newValue) => {
                  if (selectedTeamType !== "T") {
                    setSelectedLicenseTeam(newValue);
                    setSelectedLicenseRows([]);
                  }
                }}
                disabled={selectedTeamType === "T"}
                renderInput={(params) => (
                  <TextField {...params} label="Select Team" size="small" />
                )}
              />
              {selectedLicenseRows.length > 0 && (
                <Button
                  variant="contained"
                  startIcon={<IconifyIcon icon={downloadFill} />}
                  onClick={handleDownloadSelectedInvoices}
                  size="small"
                >
                  Download Invoices ({[...new Set(selectedLicenseRows.map((r) => r.invoiceFilePath).filter(Boolean))].length})
                </Button>
              )}
            </Stack>
            <BaseTable
              rows={licenseSubscriptionData}
              columns={licenseReportColumns}
              getRowId={(row) => row.id}
              loading={isTeamDetailsFetching}
              pageSize={15}
              enableSelection
              onSelectionChange={(rows) => setSelectedLicenseRows(rows)}
            />
          
        </TabPanel>
        </Card>
      </TabContext>

      <SubscriptionDetailsModal
        open={licenseSubscriptionModalOpen}
        onClose={handleLicenseSubscriptionDetailsClose}
        subscriptionData={selectedLicenseSubscriptionRow}
      />
    </Page>
  );
};

export default ReportTabList;
